import PropTypes from 'prop-types';
import classNames from 'classnames';

import styleSheet from './styles/prediction.module.scss';
import ChevronLeftIcon from '../../assets/icons/ChevronLeftIcon';
import ChevronRightIcon from '../../assets/icons/ChevronRigthIcon';
import { useCarousel } from '../../components/shared-components/hooks/useCarousel';
import { useTranslation } from 'react-i18next';

const styles = styleSheet.locals || {};

/**
 * Component which displays controller of the slider
 *
 * @param {object} props option props
 * @param {object} props.elementRef reference of slider
 * @param {object} props.children the options carousel the controls drive
 * @returns {Function} <PredictionCarouselControls />
 */
function PredictionCarouselControls({ elementRef, children }) {
    const { t } = useTranslation();
    const {
        leftArrowDisable,
        rightArrowDisable,
        pageCount,
        isIndicatorActive,
        scrollByPage
    } = useCarousel(elementRef);

    return (
        <>
            <div className={styles.predictionVoteHeader}>
                <p
                    data-cy="informText"
                    className={styles.predictionCarouselText}
                >
                    {t('predictions.carouselActions')}
                </p>
                <div
                    data-cy="carouselControl"
                    dir="ltr"
                    className={styles.predictionCarouselControls}
                >
                    <button
                        className={styles.predictionCarouselButton}
                        onClick={() => scrollByPage(-1)}
                        disabled={leftArrowDisable}
                    >
                        <ChevronLeftIcon />
                    </button>
                    <button
                        className={styles.predictionCarouselButton}
                        onClick={() => scrollByPage(1)}
                        disabled={rightArrowDisable}
                    >
                        <ChevronRightIcon />
                    </button>
                </div>
            </div>
            {children}
            <ol
                data-cy="carouselSlider"
                className={styles.predictionCarouselSlider}
            >
                {Array.from({ length: pageCount }, (unused, index) => (
                    <li
                        key={index}
                        className={classNames(
                            styles.predictionCarouselSliderIndicator,
                            {
                                [styles.predictionCarouselSliderIndicatorActive]:
                                    isIndicatorActive(index)
                            }
                        )}
                    />
                ))}
            </ol>
        </>
    );
}

PredictionCarouselControls.propTypes = {
    elementRef: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired
};

export default PredictionCarouselControls;
